import { createContext } from 'react'

export const initConfig = {
  user: {},
  isAdmin: false,
  isCoordinator: false,
  isSecurity: false,
  isSupervisor: false,
  isPersonalManager: false,
  isLmkController: false,
  isContentCoordinator: false,
  isResearcherCoordinator: false,
  isOperatorCoordinator: false,
  isMentorCoordinator: false,
  isCityManager: false,
  isPartnerSupport: false,
  isDivisionalInstructor: false,
  isHeadDivisionalInstructor: false,
  isExternalCoordinator: false,
  isPartnerMonitor: false,
  loadingData: {},
  modalData: {},
  portalButtonState: {},
  partnerData: {}
}
export const ConfigContext = createContext({
  ...initConfig,
  setConfig: () => {}
})
